/** Only explicit user input marks activity. Polling, focus and visibility do not. */
export function createSessionActivity(now = Date.now) {
    let last = now();
    return {
        mark() {
            if (now() - last < 30 * 60_000)
                last = now();
        },
        age() {
            return Math.max(0, now() - last);
        },
        recent() {
            return now() - last < 60_000;
        },
        expired() {
            return now() - last >= 30 * 60_000;
        },
        reset() {
            last = now();
        },
    };
}
//# sourceMappingURL=session-activity.js.map